import { css } from "styled-components";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { styled } from "../../../styled-components";

function scrollViewPaddingBottom(tabs: boolean, theme: RuntimeTheme) {
    return tabs ? theme.tabBar.height : 0;
}

export const ScrollWrapperStyle = styled.div<{ inTabletDetail: boolean; inTabletModal: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    ${p =>
        p.inTabletModal &&
        css`
            border-radius: 12px;
        `};

    background-color: ${p => (p.inTabletDetail ? "none" : p.theme.baseColor)};
    overflow: hidden;
`;

const paddingTop = css<{ topPadding: number }>`
    padding-left: var(--safe-area-inset-left);
    padding-right: var(--safe-area-inset-right);

    padding-top: calc(
        var(--safe-area-inset-top) + ${p => p.theme.navBar.height + p.theme.navBar.largeTitleHeight + p.topPadding}px
    );
`;

const paddingBottom = css<{ tabs: boolean | undefined; extraPadding: number }>`
    padding-bottom: calc(
        ${p => scrollViewPaddingBottom(p.tabs === true, p.theme) + p.extraPadding}px + var(--safe-area-inset-bottom)
    );
`;

interface ScrollOverlayDivProps {
    topPadding: number;
    tabs: boolean | undefined;
    extraPadding: number;
}
export const ScrollOverlayDiv = styled.div<ScrollOverlayDivProps>`
    position: absolute;
    z-index: 100;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;

    pointer-events: none;

    ${paddingTop}
    ${paddingBottom}
`;

export const ScrollOverlayContent = styled.div`
    flex-grow: 1;
    position: relative;

    & > * {
        pointer-events: auto;
    }

    .fab-target {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 16px;
        bottom: 16px;

        > * {
            margin-top: 8px;
        }
    }
`;

export const ScrollRegionStyle = styled.div<{ topPadding: number; tabs: boolean | undefined; extraPadding: number }>`
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;

    ${paddingTop}

    .map-detail & {
        padding-top: 0;
    }

    ::-webkit-scrollbar {
        display: none;
    }
    scrollbar-width: none;

    width: 100%;

    .noScroll & {
        overflow-y: hidden;
    }
`;

const tabletDetailStyles = css`
    max-width: var(--maximum-detail-width);
    background-color: ${p => p.theme.scrollView.backgroundColor};
    margin: ${p => p.theme.scrollView.marginTop}px auto;
    padding: ${p => p.theme.scrollView.paddingTop}px 0px;
    border-radius: ${p => p.theme.scrollView.borderRadius}px;
    min-height: calc(100% - ${p => p.theme.scrollView.marginTop * 2}px);
`;

// More notes to future Jason: There is a position: relative; and a z-index being set in here for
// seemingly no reason. This is because on mobile safari when your parent has webkit-overflow-scrolling
// set to true sometimes really weird things happen. Apparently safari will attempt to detect what divs
// should and should not be visible. Then it will just not render those it thinks should not be visible.
// The problem is that sometimes it is wrong, like in this case. When it is wrong it is very very wrong
// and your entire page disappears. Moving the z-index up helps it realize that the transparent sizer
// div that sometimes ends up on top of this div doesn't occlude it. I mean z-index shouldn't even do
// anything here but whatever. My point is this. If you want to remove that code, you need to test the
// ever loving shit out of mobile safari. Particularly with virutalized lists, particularly with large
// and small numbers of children. Make sure it works when switching to/from that page in all sorts of
// scenarios because the heuristic that apple uses seems to be wildly unpredictable. Seriously you
// will hate your life if you have to figure this out again.

// With love,
// Past (hopefully dumber) Jason
interface ScrollContentStyleProps {
    tabs: boolean | undefined;
    extraPadding: number;
    inTabletDetail: boolean;
}
export const ScrollContentStyle = styled.div<ScrollContentStyleProps>`
    display: flex;
    flex-direction: column;
    min-height: 100%;

    /* This overrides min-height */
    ${p => p.inTabletDetail && tabletDetailStyles}

    /* DEAR FUTURE GLIDERS AND JASON
     *
     * You will be tempted to move this padding to ScrollRegionStyle. When you do this, you will break
     * Firefox because Firefox doesn't understand how padding should work in any sane world. Seriously,
     * wtf firefox. Further, your name will be added to the comment of shame.
     *
     * People who have moved this padding and broken firefox:
     * - Jason
     * - Seth
     *
     * One of us, one of us, one of us...
     */
    ${paddingBottom}
    --bottom-bar-padding: ${p => (p.tabs === true ? p.theme.tabBar.height : 0)}px;

    @supports (-webkit-overflow-scrolling: touch) {
        min-height: calc(100% + 2px);
        padding-top: 1px;
    }

    position: relative;

    z-index: 2;

    /* .builder & {
        width: ${p => p.theme.builderWidth}px;
    } */

    /* & .content-region > div:not(.fullBleed) + div.fullBleed, 
    & > div:not(.fullBleed) + div.fullBleed {
        margin-top: 8px;
    }

    & .content-region > div:not(.fullBleed) + div:not(.fullBleed), 
    & > div:not(.fullBleed) + div:not(.fullBleed) {
        margin-top: 8px;
    }

    & .content-region > .fullBleed + .fullBleed, 
    & > .fullBleed + .fullBleed {
        margin-top: 0px;
    }
    
    & .content-region > .fullBleed + :not(.fullBleed), 
    & > .fullBleed + :not(.fullBleed) {
        margin-top: 8px;
    } */

    .drag-over & > :last-child {
        border-bottom: 2px solid #2b5fe0;
    }
`;
